import { computed, inject, Injectable, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CurrentUser, CurrentUserResponse, UserRole } from '../models/user.model';

const ALLOWED_ROLES: UserRole[] = [UserRole.FULL_ADMIN, UserRole.SUPER_ADMIN];

@Injectable({ providedIn: 'root' })
export class AuthService {
  readonly #http = inject(HttpClient);
  readonly #currentUser = signal<CurrentUser | null>(null);

  readonly hasAccess = computed(
    () => this.#currentUser()?.userRoles.some((r) => ALLOWED_ROLES.includes(r as UserRole)) ?? false,
  );

  loadCurrentUser(): Observable<CurrentUserResponse> {
    return this.#http
      .get<CurrentUserResponse>(`${environment.apiUrl}/current-user`)
      .pipe(tap((res) => this.#currentUser.set({ userRoles: res.userRoles })));
  }

  redirectToLogin(): void {
    if (environment.production) {
      window.location.href = environment.auth.loginPage;
    }
  }
}
